<template>
  <div class="index bg-181a20">
    <!-- 导航 -->
    <ao-nav navName='index'></ao-nav>
    <div class="relative">
      <div class="absolute svg-img1">
        <img src="@/assets/new3/bannerImg.c079820a.png" alt="" />
      </div>
    </div>
    <div>
      <!-- 用户共同选择 -->
      <div class="p-lr-188">
        <div class="p-t-40 relative">
          <div class="font-70 p-b-79 w-full50 wow fadeInUp animated" style="font-weight: bold;">{{$t('langNew2.zzjptgmnr')}}</div>
         <div class="flex p-b-79 wow fadeInUp animated" style="z-index: 999999;">
           <a class="a-hover" @mouseover="showhover(1)" @mouseout="hidehover" v-show="android_link" :href="android_link" title="Android" target="_blank">
             <div class="android-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-43" src="@/assets/new3/anzhuo.png" />
                 <img class="icon-mobile-show w-43 h-43" src="@/assets/new3/anzhuo-white.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">Google Play</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(2)" @mouseout="hidehover" v-show="tf_link" :href="tf_link" title="IPhone(Testflight)" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">IOS App Store</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(3)" @mouseout="hidehover" v-show="ios_link" :href="ios_link" title="IPhone(Signature)" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">iOS App Store</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(4)" @mouseout="hidehover" v-show="ios_link_2" :href="ios_link_2" title="" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">iOS App Store</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(5)" @mouseout="hidehover" v-show="ios_current_link" :href="ios_current_link" title="IPhone(Signature)" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">iOS App Store</div>
               </div>
             </div>
           </a>
         </div>

         <div class="qr-android" style="z-index: 99999;" v-show="hover == 1">
           <qriously :value="android_link" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 2">
           <qriously :value="tf_link" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 3">
           <qriously :value="ios_link" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 4">
           <qriously :value="ios_link_2" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 5">
           <qriously :value="ios_current_link" :size="128"/>
         </div>

         <div class="wow fadeInUp animated" data-wow-delay=".5s">
           <!-- <div class="p-b-124">
             <div class="p-b-20">
               <img class="w-32 h-30" src="@/assets/new3/icon_quadrangle@2x.png" alt="" />
               <span class="font-40 c-000">{{$t('langNew2.yy')}}</span>
             </div>
             <div class="font-26 c-000 p-l-40 w-full50">{{$t('langNew2.pqnr')}}</div>
           </div> -->
           <div class="p-b-124">
             <div class="p-b-20">
               <img class="w-32 h-30" src="@/assets/new3/icon_quadrangle@2x.png" alt="" />
               <span class="font-40 c-000">{{$t('langNew2.jiami')}}</span>
             </div>
             <div class="font-26 c-000 p-l-40 w-full50">{{$t('langNew2.tgnr')}}</div>
           </div>
         </div>
        </div>
        <!-- <div class="flex-b p-t-150 wow fadeInUp animated">
          <div class="">
            <div class="c-f0b90b font-97 p-b-41">187,100,654</div>
            <div class="c-fff font-71 p-b-58">{{ $t('home.user')}}</div>
            <div class="flex p-b-79" v-show="!token">
              <input type="text" class="input-reg w-512 h-67 br-10 b-1-2f3038" v-model="value" :placeholder="$t('index.register_pl')">
              <div class="flex-content w-208 h-67 font-24 c-000 br-10 bg-fcd535 m-l-40 cursor" @click="register">{{ $t('home.start')}}</div>
            </div>
            <div class="flex">
              <div class="flex-content col">
                <div class="c-fff font-34">700+</div>
                <div class="c-a0afc1 font-16">{{ $t('home.trading')}}</div>
              </div>
              <div class="op-1 b-r-1 m-lr-40"></div>
              <div class="flex-content col">
                <div class="c-fff font-34">0.01</div>
                <div class="c-a0afc1 font-16">{{ $t('home.fee')}}</div>
              </div>
              <div class="op-1 b-r-1 m-lr-40"></div>
              <div class="flex-content col">
                <div class="c-fff font-34">1000+</div>
                <div class="c-a0afc1 font-16">{{ $t('home.co')}}</div>
              </div>
              <div class="op-1 b-r-1 m-lr-40"></div>
              <div class="flex-content col">
                <div class="c-fff font-34">6</div>
                <div class="c-a0afc1 font-16">{{ $t('home.varieties')}}</div>
              </div>
            </div>
          </div>
          <div class="w-full35 relative">
            <div class="c-fff font-43 p-b-60">{{ $t('home.leading')}}</div>
            <div class="w-400 h-400 relative overflow">
                <div class="swiper-container">
                    <div class="swiper-wrapper" ref="mySwiper">
                        <div class="swiper-slide" data-index="0"><img class="w-full" src="@/assets/home/banner1.png"/></div>
                        <div class="swiper-slide" data-index="1"><img class="w-full" src="@/assets/home/banner2.png"/></div>
                        <div class="swiper-slide" data-index="2"><img class="w-full" src="@/assets/home/banner3.png"/></div>
                    </div>
                </div>
            </div>
            <div class="absolute rotate90" style="width:3.5rem;height:.7rem;top:50%;right:-1.2rem">
              <div class="swiper-pagination c-fff"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
        </div>
        <div></div> -->
      </div>
      <!-- 公告 -->
      <!-- <div class="notice-wrap m-t-110 wow fadeInUp animated">
         <div class="notice" v-show="noticeList.length > 0" v-if="lang == 'ar'">
           <router-link tag="div" class="notice-more" to="/notice" >{{$t('bzhl.ckgd')}}</router-link>
           <div class="notice-item">
             <span
               v-for="(item, index) in noticeList"
               :key="index"
               @click="notice(item.id)"
             >{{ item.title }}</span>
           </div>
           <div class="notice-new flex-content c-000 font-18">NEW</div>
         </div>
         <div class="notice" v-show="noticeList.length > 0" v-else>
           <div class="notice-new flex-content c-000 font-18">NEW</div>
           <div class="notice-item">
             <span
               v-for="(item, index) in noticeList"
               :key="index"
               @click="notice(item.id)"
             >{{ item.title }}</span>
           </div>
           <router-link tag="div" class="notice-more" to="/notice" >{{$t('bzhl.ckgd')}}</router-link>
         </div>
       </div> -->


         <div class="s_ticker  MuiBox-root mui-18oeoue" v-if="tabIndex==2">
          <div class="s_ticker_box MuiBox-root mui-k008qs">
           <ul class="MuiBox-root mui-0" v-for="(item, index) in usdtList" :key="index+'b'">
            <span class="MuiTypography-root MuiTypography-body1 mui-1k8stw6">
              <img :src="item.icon" class="w-50 h-50" style="color: transparent; margin-right: 10px;" />
              {{ item.currency | rewriteName}}
            </span>
           </ul>
           <ul class="MuiBox-root mui-0" v-for="(item, index) in usdtList" :key="index+'a'">
            <span class="MuiTypography-root MuiTypography-body1 mui-1k8stw6">
              <img :src="item.icon" class="w-50 h-50" style="color: transparent; margin-right: 10px;" />
              {{ item.currency | rewriteName}}
            </span>
           </ul>
          </div>
         </div>




      <!-- 交易品种市场趋势；k线分时图 -->
      <div class="p-lr-188">
       <!-- <div class="c-fff font-58 p-tp-142 wow fadeInUp animated">{{ $t('home.market')}}</div>
        <div class="p-b-79 wow fadeInUp animated">
          <ul class="flex-b">
            <li class="flex-b w-280 bg-212228 br-20 p-t-24 p-r-14 p-b-24 p-l-34 cursor" v-for="(item, index) in usdtList.slice(0,5)" :key="item.coin"  @click="link(item.symbol,item.type)">
              <div>
                <div class="flex p-b-22">
                  <img class="w-34 h-34" v-show="bzType == 1" :src="item.icon" />
                  <span class="c-fff font-26 p-l-10">{{ item.currency | rewriteName}}</span>
                </div>
                <div class="c-9a9a9a font-24 p-b-22">${{ item.new_price }}</div>
                <div class="c-009a62 font-25" :class="[item.grow < 0 ? 'red':'green']">{{ item.grow > 0 ? '+':'' }}{{ item.grow }}%</div>
              </div>

              <div class="flex-content">
                <trend
                  :class="item.grow < 0?'fill-red m-t-20':'fill-green m-t-20'"
                  :data="item.klinelist.map(Number)"
                  :gradient="item.grow < 0?['red']:['green']"
                  :width="85"
                  :height="27"
                  auto-draw
                  smooth
                >
                </trend>
              </div>
            </li>
          </ul>
        </div> -->

        <!-- <div class="currency-box">
            <div class="coin-list">
                <div class="coin-ul">
                    <div class="coin-li" v-for="(item,index) in shortTickers" :key="index">
                        <div class="svg-box">
                            <area-chart style="opacity: 0.2" :class="item.amplitude<0?'fall':'rise'" :market="item.coin+'_'+item.quoteUnit"></area-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- tab -->
        <div class="c-fff font-58 p-tp-142 wow fadeInUp animated">{{ $t('langNew9.dzje')}}</div>
        <div class="box03 ov wow fadeInUp animated p-b-100 box-shadow-14 br-20">
          <div class="box ov p-50">
                <ul class="tab_menu ov">
                    <li :class="{cur:tabIndex==5}" @click="tab(5,5)">{{ $t('hq.wh') }}</li>
                    <li :class="{cur:tabIndex==2}" @click="tab(2,1)">{{ $t('langNew.jmhb') }}</li>
                    <li :class="{cur:tabIndex==0}" @click="tab(0,2)">{{ $t('langNew.gjs') }}</li>
                    <li :class="{cur:tabIndex==1}" @click="tab(1,3)">{{ $t('langNew.ny') }}</li>

                </ul>
                <div class="tabox ov">
                    <div class="cont ov" style=" display:block;">
                        <div class="th">
                            <!-- <div class="td td2 t-left">{{ $t('index.thead')[0] }}</div> -->
                            <div class="td td2 t-left">{{ $t('hq.mc') }}</div>
                            <div class="td td1">{{ $t('index.thead')[1] }}</div>
                            <div class="td td1">{{$t('hq.tb')}}</div>
                            <!-- <div class="td td1">{{ $t('index.thead')[2] }}</div>
                            <div class="td td1">{{ $t('index.thead')[3] }}</div> -->
                            <div class="td td1">{{ $t('index.thead')[4] }}</div>
                            <div class="td td1">{{ $t('index.thead')[5] }}</div>
                            <div class="td td1">{{ $t('index.thead')[6] }}</div>
                        </div>
                        <div class="tr" v-for="(item, index) in usdtList" :key="index">
                          <div class="td td2 t-left"><img v-if="item.type != 2 && item.type != 3" :src="item.icon">{{ item.currency | rewriteName}}<span v-show="item.type != 5">/USDT</span></div>
                          <div class="td td1"><span>{{ item.new_price }}</span> <span class="aaa"></span> <span class="aaa"></span></div>
                          <div class="td td1">
                            <trend
                              :class="item.grow < 0?'fill-red m-t-20':'fill-green m-t-20'"
                              :data="item.klinelist.map(Number)"
                              :gradient="item.grow < 0?['red']:['green']"
                              :width="85"
                              :height="27"
                              auto-draw
                              smooth
                            >
                            </trend>
                          </div>
                          <!-- <div class="td td1"><span>{{ item.high }}</span></div> <div class="td td1"><span>{{ item.low }}</span></div> -->
                          <div class="td td1"><span :class="[item.grow < 0 ? 'red':'green']">{{ item.grow > 0 ? '+':'' }}{{ item.grow }}%</span></div>
                          <div class="td td1">{{ item.vol }}</div>
                          <div class="td td1 cursor"><span class="w-72 h-30 p-t-6 p-b-6 p-l-20 p-r-20 c-000 bg-fcd535 br-15 font-15" @click="link(item.symbol,item.type)">{{ $t('index.btn') }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>


      <!-- 开启您的数字交易历程 -->
      <div class="p-lr-188">
        <div class="c-fff font-58 p-tp-142 wow fadeInUp animated" data-wow-delay=".5s">
          {{ $t('langNew9.lxyxzc')}}
        </div>
        <div class="flex-b m-b-30">
          <div class="wow fadeInUp animated" data-wow-delay=".5s">
            <img class="w-700 h-400" src="@/assets/new3/bg3.0733f40a.png" />
          </div>
          <div class="p-l-247 wow fadeInUp animated" data-wow-delay=".5s">
            <!-- <div class="c-fff font-54">{{ $t('home.pc_anytime')}}</div>
            <div class="c-fff font-20 p-tb-74">{{ $t('home.pc_text')}}</div> -->
            <div>
              <div class="li-hover flex-content p-40 br-20 cursor" @click="jumpUrl('/register')">
                <div class="flex-content bg-fcd437 w-76 h-76 br-100 font-48 m-r-30">1</div>
                <div class="w-full80">
                  <div class="font-40 c-000 p-b-10 font-b">{{ $t('langNew9.text1')}}</div>
                  <div class="font-22 c-9f9f9f">{{ $t('langNew9.text2')}}</div>
                </div>
              </div>
              <div class="li-hover flex-content p-40 br-20 cursor" @click="jumpUrl('/recharge')">
                <div class="flex-content bg-fcd437 w-76 h-76 br-100 font-48 m-r-30">2</div>
                <div class="w-full80">
                  <div class="font-40 c-000 p-b-10 font-b">{{ $t('langNew9.text3')}}</div>
                  <div class="font-22 c-9f9f9f">{{ $t('langNew9.text4')}}</div>
                </div>
              </div>
              <div class="li-hover flex-content p-40 br-20 cursor" @click="jumpUrl('/deal_jg')">
                <div class="flex-content bg-fcd437 w-76 h-76 br-100 font-48 m-r-30">3</div>
                <div class="w-full80">
                  <div class="font-40 c-000 p-b-10 font-b">{{ $t('langNew9.text5')}}</div>
                  <div class="font-22 c-9f9f9f">{{ $t('langNew9.text6')}}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- 手机PC端均可使用 -->
      <div class="pc-bg flex-content p-tb-30" style="align-items: flex-start;">
        <div class="p-lr-188 c-fff font-58 p-tp-142 wow fadeInUp animated" data-wow-delay=".5s">
          {{ $t('home.mobile_pc')}}
        </div>
        <div class="pc-bg-img">

        </div>
        <!-- <div class="flex-b">
          <div class="wow fadeInUp animated" data-wow-delay=".5s">
            <img class="w-742 h-541" src="@/assets/home/PC-PHONE.png" />
          </div>
          <div class="p-l-247 wow fadeInUp animated" data-wow-delay=".5s">
            <div class="c-fff font-54">{{ $t('home.pc_anytime')}}</div>
            <div class="c-fff font-20 p-tb-74">{{ $t('home.pc_text')}}</div>
            <div class="flex">
              <a v-show="android_link" :href="android_link" title="Android" target="_blank">
                <div class="android-btn flex-content br-10 p-lr-20 h-58 b-1">
                  <div class="">
                    <img class="icon-mobile-hide w-40 h-40" src="@/assets/home/anzhuo.png" />
                    <img class="icon-mobile-show w-40 h-40" src="@/assets/home/anzhuo-b.png" />
                  </div>
                  <div class="p-l-10">
                    <div class="c-fff font-14">{{ $t('home.mobile_down')}}</div>
                    <div class="c-fff font-14">{{ $t('home.mobile_android')}}</div>
                  </div>
                </div>
              </a>
              <a v-show="tf_link" :href="tf_link" title="IPhone(Testflight)" target="_blank">
                <div class="ios-btn flex-content br-10 p-lr-20 h-58 b-1 m-l-20">
                  <div class="">
                    <img class="icon-mobile-hide w-40 h-40" src="@/assets/home/ios.png" />
                    <img class="icon-mobile-show w-40 h-40" src="@/assets/home/ios-b.png" />
                  </div>
                  <div class="p-l-10">
                    <div class="c-fff font-14">{{ $t('home.mobile_down')}}</div>
                    <div class="c-fff font-14">{{ $t('home.mobile_ios')}}</div>
                  </div>
                </div>
              </a>
              <a v-show="ios_link" :href="ios_link" title="IPhone(Signature)" target="_blank">
                <div class="ios-btn flex-content br-10 p-lr-20 h-58 b-1 m-l-20">
                  <div class="">
                    <img class="icon-mobile-hide w-40 h-40" src="@/assets/home/ios.png" />
                    <img class="icon-mobile-show w-40 h-40" src="@/assets/home/ios-b.png" />
                  </div>
                  <div class="p-l-10">
                    <div class="c-fff font-14">{{ $t('home.mobile_down')}}</div>
                    <div class="c-fff font-14">{{ $t('home.mobile_ios')}}</div>
                  </div>
                </div>
              </a>
              <a v-show="ios_link_2" :href="ios_link_2" title="" target="_blank">
                <div class="ios-btn flex-content br-10 p-lr-20 h-58 b-1 m-l-20">
                  <div class="">
                    <img class="icon-mobile-hide w-40 h-40" src="@/assets/home/ios.png" />
                    <img class="icon-mobile-show w-40 h-40" src="@/assets/home/ios-b.png" />
                  </div>
                  <div class="p-l-10">
                    <div class="c-fff font-14">{{ $t('home.mobile_down')}}</div>
                    <div class="c-fff font-14">{{ $t('home.mobile_ios')}}</div>
                  </div>
                </div>
              </a>
              <a v-show="ios_current_link" :href="ios_current_link" title="IPhone(Signature)" target="_blank">
                <div class="ios-btn flex-content br-10 p-lr-20 h-58 b-1 m-l-20">
                  <div class="">
                    <img class="icon-mobile-hide w-40 h-40" src="@/assets/home/ios.png" />
                    <img class="icon-mobile-show w-40 h-40" src="@/assets/home/ios-b.png" />
                  </div>
                  <div class="p-l-10">
                    <div class="c-fff font-14">{{ $t('home.mobile_down')}}</div>
                    <div class="c-fff font-14">{{ $t('home.mobile_ios')}}</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 探索无限可能 -->
      <div class="p-lr-188">
        <div class="c-fff font-58 p-tp-142 wow fadeInUp animated">{{ $t('home.explore')}}</div>
        <div class="flex-b m-b-100">
          <div class="bg-hover w-400 h-570 flex-content col p-lr-30 br-30 wow fadeInUp animated" data-wow-delay=".2s">
            <div class="p-b-50">
              <img class="w-177 h-184" src="@/assets/home/Practical-functions1.png" />
            </div>
            <div class="c-fff font-40">{{ $t('langNew9.text11')}}</div>
            <div class="c-929292 font-24 p-tb-50 t-center">{{ $t('langNew9.text12')}}</div>
            <div class="op-0 op-hover c-000 font-20 t-center cursor" @click="jump('/market')">{{ $t('home.get_start')}}→</div>
          </div>
          <!-- 邀请好友 -->
          <!-- <div class="bg-hover w-400 h-570 flex-content col p-lr-30 br-30 wow fadeInUp animated" data-wow-delay=".2s">
            <div class="p-b-50">
              <img class="w-185 h-192" src="@/assets/home/picture_new@2x.png" />
            </div>
            <div class="c-fff font-40">{{ $t('langNew9.text7')}}</div>
            <div class="c-929292 font-24 p-tb-50 t-center">{{ $t('langNew9.text8')}}</div>
            <div class="op-0 op-hover c-000 font-20 t-center cursor" @click="jump('/invite')">{{ $t('home.get_start')}}→</div>
          </div> -->
          <div class="bg-hover w-400 h-570 flex-content col p-lr-30 br-30 wow fadeInUp animated" data-wow-delay=".2s">
            <div class="p-b-50">
              <img class="w-185 h-192" src="@/assets/home/picture_new@2x.png" />
            </div>
            <div class="c-fff font-40">{{ $t('bank.text2')}}</div>
            <div class="c-929292 font-24 p-tb-50 t-center">{{ $t('bank.text3')}}</div>
            <div class="op-0 op-hover c-000 font-20 t-center cursor" @click="jump('/settingNew')">{{ $t('home.get_start')}}→</div>
          </div>
          <div class="bg-hover w-400 h-570 flex-content col p-lr-30 br-30 wow fadeInUp animated" data-wow-delay=".2s">
            <div class="p-b-50">
              <img class="w-169 h-192" src="@/assets/home/Practical-functions3.png" />
            </div>
            <div class="c-fff font-40">{{ $t('langNew9.text9')}}</div>
            <div class="c-929292 font-24 p-tb-50 t-center">{{ $t('langNew9.text10')}}</div>
            <div class="op-0 op-hover c-000 font-20 t-center cursor" @click="jump('/currency')">{{ $t('home.get_start')}}→</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开设账户 -->
    <!-- <div class="flex-content col bg-img h-406 c-fff wow fadeInUp animated" v-show="!token">
      <div class="c-fff font-40">{{ $t('home.open_text')}}</div>
      <div class="flex-content br-10 w-208 h-67 bg-fcd535 c-000 font-24 m-t-60 cursor" @click="register">{{ $t('home.open_account')}}</div>
    </div> -->

    <!-- 脚部 -->
    <ao-footer></ao-footer>
    <!-- 公告弹窗 -->
    <div class="mask-notice" v-show="isNotice">
      <div class="notice-alert-wrap box-shadow-14">
          <div class="title">{{ $t('news.gg') }}</div>
          <div class="cont" v-html="noticeHtml"></div>
          <div class="notice-btn" @click="goDetail">{{ $t('news.ckxq') }}</div>
          <img class="btn-close" @click="noticeClose" src="@/assets/login_delete.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import AoNav from "@/components/AoNav";
import AoFooter from "@/components/AoFooter";
// import areaChart from '@/components/areaChart.vue'
import pic from '@/utils/pic'

import { marke_price,number_round } from '@/utils/index'

import { getGG, getmarketList, getBanner, getQrcode,getParam,getText } from "@/api/index";
var index_timer = null;
let intervalId = null;
import iconLeft from "@/assets/icon-left.png";
import iconRight from "@/assets/icon-right.png";
import iconRightHome from "@/assets/Home_banner_icon.png";
import zheXian from "@/assets/zhexian.png";
import { mapGetters } from "vuex";
let vm = null;
export default {
  components: {
    AoNav,
    AoFooter
  },
  data() {
    return {
      //shortTickers: [{coin: "ETC",quoteUnit: "USDT"},{coin: "XIL",quoteUnit: "USDT"},{coin: "FIL",quoteUnit: "USDT"},{coin: "DOGE",quoteUnit: "USDT"}], // 顶部四个交易对
      iconbg: pic.iconbg,
      indexphone: pic.indexphone,
      bannerList: [],
      usdtList: [],
      oldList: [],
      noticeList: [],
      index: 0,
      value: '',
      dealsIndex: 0,
      tabIndex: 2,

      featureTitle2: this.$t("index.featureTitle2"),
      featureMsg2: this.$t("index.featureMsg2"),

      iconLeft:iconLeft,
      iconRight: iconRight,
      iconRightHome: iconRightHome,
      zheXian: zheXian,
      iconDirection: 1,
      lClass: '',
      rClass: '',
      type: 'text',
      swiper: null,
      qrcode: {},
      currencyList: [],
      android_link: "",
      ios_link: "",
      tf_link: "",
      ios_link_2: "",
      ios_current_link: "",
      isNotice: false,
      noticeId: '',
      noticeHtml: '',
      isNoticeShow: '',
      lang: 'en',
      bzType: 1,
      hover:0,
      trendArr:[],//分时图数组
    };
  },
  computed: {
    ...mapGetters(["token"])
  },
  created(){
    vm = this;
  },
  mounted() {
    this.lang = localStorage.getItem('lang') || 'en';

    getBanner().then(res => {
      this.bannerList = res;
      // setTimeout(() => {
      //   this.swiper = new Swiper('.swiper-container',{
      //       direction: 'vertical', // 垂直切换选项
      //       // height: 'auto',
      //       slidesPerView: 1,
      //       // spaceBetween: 30,
      //       autoplay:true,
      //       loop: true,
      //       // observer:true,  //修改swiper自己或子元素时，自动初始化swiper
      //       // observeParents:true,  //修改swiper的父元素时，自动初始化swiper
      //       autoplay: {
      //           delay: 2000,
      //           disableOnInteraction: false
      //       },
      //       pagination: {
      //         el: '.swiper-pagination',
      //         // type: 'custom',
      //         // type: 'fraction',
      //         clickable: true,
      //         renderBullet: function (index, className) {
      //           return '<span style="width:.5rem;height:.5rem;line-height: .5rem;" class="' + className + '">' + (index + 1) + "</span>";
      //         }
      //       },
      //       // 如果需要前进后退按钮
      //       navigation: {
      //         nextEl: '.swiper-button-next',
      //         prevEl: '.swiper-button-prev',
      //       },
      //       on:{
      //           // click: ()=>{
      //           //     let swiper = this.$refs.mySwiper.$swiper;
      //           //     let i = JSON.parse(this.swiper.clickedSlide.attributes['data-index'].nodeValue);
      //           //     vm.bannerLink(i);
      //           // }
      //       },
      //   })
      //   // 旧版的横向轮播
      //   // this.swiper = new Swiper('.swiper-container',{
      //   //     slidesPerView: 3,
      //   //     spaceBetween: 30,
      //   //     autoplay:true,
      //   //     loop: true,
      //   //     observer:true,  //修改swiper自己或子元素时，自动初始化swiper
      //   //     observeParents:true,  //修改swiper的父元素时，自动初始化swiper
      //   //     autoplay: {
      //   //         delay: 3000,
      //   //         disableOnInteraction: false
      //   //     },
      //   //     pagination: {
      //   //       el: '.swiper-pagination',
      //   //       clickable: true,
      //   //     },
      //   //     on:{
      //   //         click: ()=>{
      //   //             let swiper = this.$refs.mySwiper.$swiper;
      //   //             let i = JSON.parse(this.swiper.clickedSlide.attributes['data-index'].nodeValue);
      //   //             vm.bannerLink(i);
      //   //         }
      //   //     },
      //   // })
      // }, 0)
    })
    getGG().then(res => {
      var noticeArr = [];
      this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
      this.noticeList = res;

      if(res.length > 0){
        noticeArr = res.filter((item,index) =>{
					if(item.is_popover == 1){
						return true;
					}else{
						return ''
					}
				});
				if(noticeArr.length > 0){
					if(this.isNoticeShow){
						this.isNotice = false;
					}else{
						this.isNotice = true;
					}
					this.noticeId = noticeArr[0].id;
					this.getDetail(this.noticeId);
				}
			}else{
				this.isNotice = false
			}
    });
    getQrcode().then(res => {
      this.qrcode = res
    });
    getParam().then(res => {
      for(var i=0;i< res.length; i++){
        if(res[i].key == 'android_link'){
          this.android_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_link'){
          this.ios_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'tf_link'){
          this.tf_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'online_service'){
          localStorage.setItem('online_service',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'online_service2'){
          localStorage.setItem('online_service2',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'ios_link_2'){
          this.ios_link_2 = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_current_link'){
          this.ios_current_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }
      }
    });
    this.getmarketList();
    this.initWebSocket();
    let that = this;
    // that.getNewTimeshar()

    // intervalId = setInterval(()=>{
    //   that.getNewTimeshar()
    // }, 10000);

    if(window.GLOBAL.is_sw_market){
      __socket.emit("index", 'index');
      __socket.on("daymarket", msg => {
        if (typeof msg === 'string') msg = JSON.parse(msg)
        if (msg.type == "daymarket") {
          //tabIndex 0=主流币 1=涨幅币
          var arr = this.usdtList.concat([])
          arr.forEach(o => {
            if (o.symbol == msg.symbol) {
              o.grow = number_round(msg.change, window.GLOBAL.NUMBER_ROUND_2)
              o.vol = number_round(msg.volume)
              o.new_price = number_round(marke_price(msg.now_price, o.is_control,o.buy_control_value,o.risk_value))
            }
          })
          if(this.tabIndex==1){
            this.sort(arr)
          }else{
            this.usdtList = arr
          }
        }
      });
    }

    this.$nextTick(() => {
      new this.$wow.WOW({resetAnimation: false,live: false }).init()
    })
  },
  destroyed() {
    index_timer&&clearInterval(index_timer);
    intervalId&&clearInterval(intervalId);
  },
  methods: {
    jumpUrl(url){
      this.$router.push(url);
    },
    showhover(e){
      this.hover = e
    },
    hidehover(){
      this.hover = 0
    },
    getNewTimeshar(){
      let that = this
      // let symbolArr = null;
      // if(this.tabIndex == 0){
      //   symbolArr = ["XAU","BRT","XAG"]
      // }else if(this.tabIndex == 1){
      //   symbolArr = ["OILFUT","NYMEX","NG","XPD","PTB"]
      // }else{
      //   symbolArr = ["btc","eth","doge","space","eos"]
      // }
      let symbolArr = ["btc","eth","doge","eos","ltc"];

      for (let item of symbolArr) {
          $.ajax({
              url: window.GLOBAL.HOST + 'web/new_timeshar?symbol=' + item.toLowerCase() +'usdt&period=1min',
              type:'get',
              success: function(res){
                if(res.data&&res.data.length){
                  that.trendArr[item] = res.data.map(item=>{
                    return Number(item.Close)
                  })
                  // console.log(that)
                  // console.log(that.trendArr)
                }
              }
          })
      }
    },
    jump(path){
      if(path=='/deal_c'){
        localStorage.setItem('type',2)
      }
      if(path=='/deal'){
        localStorage.setItem('type',1)
      }
      if(path=='/deal_jg'){
        localStorage.setItem('type',3)
      }
      if(path=='/preciousMetal'){
        localStorage.setItem('type',2)
      }
      if(path=='/contractTransaction'){
        localStorage.setItem('type',3)
      }
      this.$router.push({ path: path });
    },
    move() {
      this.lClass = this.iconDirection ? 'l2' : ''
      this.rClass = this.iconDirection ? 'r2' : ''
      this.type = this.iconDirection ? 'card' : ''
      this.iconDirection = ! this.iconDirection
    },
    tab(i,type){
      this.tabIndex = i;
      this.bzType = type;
      this.usdtList = [];
      if(i==3){
        this.sort(this.usdtList.concat([]))
      }else{
        this.getmarketList();
      }
    },
    sort(data) {
      data.sort(function(a,b){
        return Number(a.grow) - Number(b.grow)
      }).reverse();
      this.currencyList = [];
      this.usdtList = data;
      for(var jj in data){
        this.currencyList[this.usdtList[jj].currency] = [this.usdtList[jj].change] ;
      }
    },
    link(a,type) {
      localStorage.setItem('type',2)
      this.$router.push({ path: '/deal_c', query: { symbol: a ,selfType : type} })
      // if(type == 1){
      //   localStorage.setItem('type',3)
      //   this.$router.push({ path: '/deal_c', query: { symbol: a ,selfType : type} })
      // }else{
      //   localStorage.setItem('type',3)
      //   this.$router.push({ path: '/contractTransaction', query: { symbol: a,selfType : type } })
      // }
    },
    more() {
      this.$router.push({ path: '/market', query: {  } })
    },
    register() {
      this.$router.push({ path: '/register', query: { v: this.value } })
    },
    getmarketList() {
      let that = this
      getmarketList({id:1,type:this.bzType}).then(res => {
        this.usdtList = res;
        this.oldList = res;
        this.currencyList = [];
        for (var curr in res){
          this.currencyList[this.usdtList[curr].currency] = [this.usdtList[curr].change,this.usdtList[curr].symbol];
        }
      });
    },
    initWebSocket(){ //初始化weosocket
					const wsuri = window.GLOBAL.webSocket;
					this.websock = new WebSocket(wsuri);
					this.websock.onmessage = this.websocketonmessage;
					this.websock.onopen = this.websocketonopen;
					this.websock.onerror = this.websocketonerror;
					this.websock.onclose = this.websocketclose;
				},
				websocketonopen(){ //连接建立之后执行send方法发送数据
					// var msg = {'time_type': vm.timeType,'currency_type':vm.currency_type,'uid': vm.uid};
					// this.websocketsend(JSON.stringify(msg));
				},
				websocketonerror(){//连接建立失败重连
					this.initWebSocket();
				},
				websocketonmessage(e){ //数据接收
         if(JSON.parse(e.data).action == "marketprice"){
           let msg = JSON.parse(e.data).content;
            let keyArr = [];
            for(var x in this.currencyList){
              for(var y in this.usdtList){
                x = this.bzType == 1 ? x.toLowerCase() : x;
                if(!msg[x]) return;
                if(msg[x].symbol == this.usdtList[y].symbol){
                  this.usdtList[y]['new_price'] = msg[x].now_price;
                  this.usdtList[y]['grow'] = msg[x].change;
                  keyArr.push(this.usdtList[y]);
                  break;
                }
              }
            }
            this.usdtList = keyArr;
         }

				},
				websocketsend(Data){//数据发送
					this.websock.send(Data);
				},
				websocketclose(e){  //关闭
					console.log('断开连接',e);
				},
    bannerLink(i){
      let id = this.bannerList[i].id;
      let content = this.bannerList[i].content;
      if(id){
        if(this.filterHtmlTag(content)){
          this.$router.push({
            path: "/bannerDetail",
            query: { id }
          });
        }
      }
    },
    filterHtmlTag(msg){
      var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
          msg = msg.replace(/[|]*\n/, '') //去除行尾空格
          msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
          return msg;
    },
    notice(id) {
      this.$router.push({
        path: "/notice",
        query: { id }
      });
    },
    getClass(grow) {
      return parseFloat(grow) < 0 ? "down" : "";
    },
    change(index) {
      this.index = index;
    },
    downLoad(){
      this.$router.push('/downLoad');
    },
    goDetail(){
      let id = this.noticeId;
			 this.$router.push({
        path: "/notice",
        query: { id }
      });
		},
    getDetail(id){
      getText({id:id}).then(res => {
        if (res && res.content) {
          this.noticeHtml = res.content;
        }
      })
    },
    noticeClose(){
			if(this.isNoticeShow != null){
				this.isNotice = true;
				sessionStorage.removeItem('isNoticeShow');
			}else{
				this.isNotice = false;
				sessionStorage.setItem('isNoticeShow',true);
			}
		},
  }
};
</script>

<style lang="scss" scoped>
  .li-hover:hover{
        box-shadow: 0px 11px 51px 0px rgba(0, 0, 0, .14);
  }
  // .bg-hover:hover{
  //   background-color: #212228;
  // }
  // .bg-hover:hover .op-hover{
  //   opacity: 1;
  // }
  // .input-reg{
  //   color: #a8a8a8;
  //   text-indent: .2rem;
  // }
  // .icon-mobile-show{
  //   display: none;
  // }
  // .android-btn:hover{
  //   background-color: #000;
  //   cursor: pointer;
  //   border: none;
  //   div{
  //     color: #fff;
  //   }
  //   .icon-mobile-show{
  //     display: block;
  //   }
  //   .icon-mobile-hide{
  //     display: none;
  //   }
  // }
  // .ios-btn:hover{
  //   background-color: #000;
  //   cursor: pointer;
  //   border: none;
  //   div{
  //     color: #fff;
  //   }
  //   .icon-mobile-show{
  //     display: block;
  //   }
  //   .icon-mobile-hide{
  //     display: none;
  //   }
  // }
  .android-btn,.ios-btn{
    border: 1px solid #000;
    padding:10px 0;
  }
  .a-hover{
    // position: relative;
    // height: .94rem;
  }
  .a-hover:hover{
    .icon-mobile-show{
      display: block;
    }
  }
  .qr-android{
    position: absolute;
    top: 45%;
    box-shadow: 0px 0px 0px 6px #eee;height: 132px;width: 132px;margin: 10px 0 0 20px;text-align:center;background: #fff
  }
  .qr-ios{
    position: absolute;
    top: 45%;
    left: 15%;
    box-shadow: 0px 0px 0px 6px #eee;height: 132px;width: 132px;margin: 10px 0 0 30px;text-align:center;background: #fff
  }
  .svg-img1{
    top: 30px;
    right: 40px;
  }
  .svg-img1 img{
    width: 7.51rem;
    height: 5.27rem;
    // width: 7.878rem;
    // height: 16.406rem;
  }
  .pc-bg{
    display: flex;
    width:auto;
    height:700px;
    background-color: #f5f5f5;
    flex-direction: column;
    // background-size: cover;
      // background-position: center;
  }
  .pc-bg-img{
    width: 1263px;
    height: 880px;
    margin: -150px auto 0;
    background-image: url('../assets/new3/bg3.0733f40b.jpg');
    background-size: 100% 100%;
  }
  .fill-red >>> path {
    fill:rgba(255,0,0,0.5);
  }
  .fill-green >>> path {
    fill:rgba(0,128,0,0.5);
  }
  .bg-img{
    background-image: url('../assets/home/picture1.png');
    background-size: 100% 100%;
  }
  .bg-hover:hover{
    // background-color: #ffffff;
    box-shadow: 0px 11px 51px 0px rgba(0, 0, 0, .14);
  }
  .bg-hover:hover .op-hover{
    opacity: 1;
  }
  .input-reg{
    color: #a8a8a8;
    text-indent: .2rem;
  }
  .icon-mobile-show{
    display: none;
  }
  .android-btn:hover{
    background-color: #fcd535;
    cursor: pointer;
    border: none;
    div{
      color: #fff;
    }
    .icon-mobile-show{
      display: block;
    }
    .icon-mobile-hide{
      display: none;
    }
  }
  .ios-btn:hover{
    background-color: #fcd535;
    cursor: pointer;
    border: none;
    div{
      color: #fff;
    }
    .icon-mobile-show{
      display: block;
    }
    .icon-mobile-hide{
      display: none;
    }
  }

.rise {
  text-align: center;
}
.fall {
  text-align: center;
}
.rise span,.fall span{
  display:inline-block;
  width: 83px;
  height: 32px;
  line-height: 32px;
  background: rgba(220, 86, 86, .13);
  border-radius: 2px;
}
.coin-li-head > .rise span{
  width:70px;
  height:24px;
  line-height:24px;
  color: #27af87 !important;
}
.coin-li-head > .fall span{
  width:70px;
  height:24px;
  line-height:24px;
  color: #e05a5a !important;
}

  .box03{ width:100%;}
  .box03 .box{ width:1200px; margin:auto;}
  .box03 .title{ float:left; color: #000000;font-size:40px; line-height:50px; font-weight:bold;}
  .box03 .tab_menu{ display:block;}
  .box03 .tab_menu li{ display:block; font-size:.34rem; line-height:.73rem; height:.73rem; border-bottom:2px solid rgba(0,0,0,0); float:left; margin-right:30px; color:#7d7d7d; cursor:pointer;}
  .box03 .tab_menu li.cur{
    padding: 0 10px;
  	height: .73rem;line-height: .73rem;text-align: center;
  	background-color: #fcd535;
  	border-radius: .1rem;color:#000;}
  .box03 .tabox{ width:1200px; float:left; margin-top:30px;}
  .box03 .tabox .cont{ width:100%;}
  .box03 .tabox .cont .th{ width:100%; overflow:hidden; font-size:16px; color:#7d7d7d;}
  .box03 .tabox .cont .td{ float:left; line-height:60px; height:60px;text-align: right;}
  .box03 .tabox .cont .th .td:nth-child(1){ text-align: left;}
  .box03 .tabox .cont .tr .td:nth-child(1){ text-align: left;}
  .box03 .tabox .cont .td2{ width:19%; }
  .box03 .tabox .cont .td1{ width:13.5%;text-align: center;}
  .box03 .tabox .cont .tr{ overflow:hidden; font-size:14px; border-radius:5px; color:#000000;}
  .box03 .tabox .cont .tr:nth-child(2n){ background-color:transparent;}
  .box03 .tabox .cont .tr .td2{ text-align:right; box-sizing:border-box;}
  .box03 .tabox .cont .tr .td1 a:hover{ color:#00d5fd;}
  .box03 .tabox .cont .td2 img{ width:26px; border-radius:100%; overflow:hidden; height:26px; margin-right:10px; display:block; float:left; margin-top:17px;}
  .red{ color:red;}
  .green{ color:green;}

// $nav-height: 3*16/100 rem;
// $font-size-mini:.75*16/100 rem;
// $font-size-small: .875*16/100 rem;
// $font-size:1*16/100 rem;
// $font-size-large:1.125*16/100 rem;
// $font-size-big:1.6*16/100 rem;
// $blue:#2558d9;
// $green:#4db872;
// $red:#ee6560;
// $aaa: #aaa;
// $eee:#eee;
// $c3: #333;
// $c6: #666;


// $color: #dbdde1;
// $hoverColor: #dbdde1;
// $activeColor: #dbdde1;
// $borderColor:#2558d9;

// $nav-background-color: #0e1936;
// $background-color:#0e1014;

// $background:#000000;
// $background-blue:#2558d9;
// $background-green:#0d8551;

// .banner{ width:100%; height:540px; background-position:center; background-repeat:no-repeat; position:relative; z-index:0;}
// .banner .box{ width:1200px; position:absolute; top:50%; left:50%; transform:translateX(-50%) translateY(-50%);}
// .banner .box .wen{ width:520px; float:right;}
// .banner .wen b{ font-size:40px; line-height:60px; display:block; color:#000000;}
// .banner .wen p{ width:100%; margin-top:10px; font-size:18px; line-height:28px; color:#000000;}
// .banner .ser{ clear:right; float:right; width:440px; margin:30px 0; margin-right:80px; border:1px solid #00d5fd; border-radius:5px;}
// .banner .ser input{ background-color:#17191a; width:338px; height:44px; line-height:44px; display:block; float:left; text-indent:20px; font-size:14px; border-radius:5px; overflow:hidden; color:#000000;}
// .banner .ser a{ width:100px; height:44px; line-height:44px; display:block; float:left; text-align:center; color:#000000; background-color:#00d5fd; font-size:14px; overflow:hidden;}
// .banner{
//   background-image: url('../assets/new/banner.jpg');
// }
// .box01{ width:100%; margin-top:70px;}
// .box01 .box{ width:1200px; margin:auto; display:flex; align-items:center;}
// .box01 .box .left{ width:600px; margin-left:200px;}
// .box01 .box .left .b01{ font-size:40px; font-weight:bold; color:#000000; line-height:50px;}
// .box01 .box .left .b02{ font-size:16px; color:#99b3da; line-height:26px; margin-top:20px;}
// .box01 .box .left .b03{ width:100%; margin-top:30px;}
// .box01 .box .left .b03 p{ display:block; float:left; margin-right:50px;}
// .box01 .box .left .b03 p b{ display:block; color:#00d5fd; font-size:40px;}
// .box01 .box .left .b03 p span{ display:block; color:#99b3da; font-size:16px; line-height:26px;}
// .box01 .box .right{ width:400px; border-radius:10px;}
// .box01 .box .right img{ width:100%; display:block;}

// .box02{ width:100%; margin-top:70px;}
// .box02 .box{ width:1200px; margin:auto; display:flex; align-items:center;}
// .box02 .box .left{ width:700px; margin-right:100px;}
// .box02 .box .left .b01{ font-size:40px; font-weight:bold; color:#000000; line-height:50px;}
// .box02 .box .left .b02{ font-size:16px; color:#99b3da; line-height:26px; margin-top:20px;}
// .box02 .box .left .b03{ width:100%; margin-top:30px;}
// .box02 .box .left .b03 p{ display:block; float:left; margin-right:50px;}
// .box02 .box .left .b03 p b{ display:block; color:#00d5fd; font-size:40px;}
// .box02 .box .left .b03 p span{ display:block; color:#99b3da; font-size:16px; line-height:26px;}
// .box02 .box .right{ width:400px; border-radius:10px;}
// .box02 .box .right img{ width:100%; display:block;}

// .box03{ width:100%;}
// .box03 .box{ width:1200px; margin:auto;}
// .box03 .title{ float:left; color: #000000;font-size:40px; line-height:50px; font-weight:bold;}
// .box03 .tab_menu{ display:block;}
// .box03 .tab_menu li{ display:block; font-size:.34rem; line-height:.73rem; height:.73rem; border-bottom:2px solid rgba(0,0,0,0); float:left; margin-right:30px; color:#7d7d7d; cursor:pointer;}
// .box03 .tab_menu li.cur{ width: 1.6rem;
// 	height: .73rem;line-height: .73rem;text-align: center;
// 	background-color: #fcd535;
// 	border-radius: .1rem;color:#000;}
// .box03 .tabox{ width:1200px; float:left; margin-top:30px;}
// .box03 .tabox .cont{ width:100%;}
// .box03 .tabox .cont .th{ width:100%; overflow:hidden; font-size:16px; color:#7d7d7d;}
// .box03 .tabox .cont .td{ float:left; line-height:60px; height:60px;text-align: right;}
// .box03 .tabox .cont .th .td:nth-child(1){ text-align: left;}
// .box03 .tabox .cont .tr .td:nth-child(1){ text-align: left;}
// .box03 .tabox .cont .td2{ width:19%; }
// .box03 .tabox .cont .td1{ width:13.5%; }
// .box03 .tabox .cont .tr{ overflow:hidden; font-size:14px; border-radius:5px; color:#000000;}
// .box03 .tabox .cont .tr:nth-child(2n){ background-color:transparent;}
// .box03 .tabox .cont .tr .td2{ text-align:right; box-sizing:border-box;}
// .box03 .tabox .cont .tr .td1 a:hover{ color:#00d5fd;}
// .box03 .tabox .cont .td2 img{ width:26px; border-radius:100%; overflow:hidden; height:26px; margin-right:10px; display:block; float:left; margin-top:17px;}
// .red{ color:red;}
// .green{ color:green;}

// .box04{ width:100%; margin-top:70px;}
// .box04 .box{ width:1200px; margin:auto; display:flex; align-items:center;}
// .box04 .box .left{ width:680px; margin-right:120px;}
// .box04 .box .left .title{ font-size:40px; font-weight:bold; color:#000000; line-height:50px;}
// .box04 .box .left .wen{ font-size:18px; line-height:28px; color:#000000; margin-top:10px; opacity:0.3;}
// .box04 .box .left .list{ display:block; margin-top:15px;}
// .box04 .box .left .list li{ display:block; overflow:hidden; margin-top:20px;}
// .box04 .box .left .list li b{ font-size:24px; line-height:34px; color:#000000; display:block; overflow:hidden;}
// .box04 .box .left .list li p{ font-size:16px; line-height:26px; color:#99b3da; display:block; overflow:hidden; margin-top:10px;}
// .box04 .box .right{ width:400px;}
// .box04 .box .right img{ width:100%; display:block;}

// .box05{ width:100%; margin-top:70px;}
// .box05 .box{ width:1200px; margin:auto;}
// .box05 .box .left{ width:500px; float:right;}
// .box05 .box .left .wen{ padding:30px; background-color:#00d5fd; border-radius:10px;}
// .box05 .box .left .b01{ font-size:40px; font-weight:bold; color:#333; line-height:50px;}
// .box05 .box .left .b02{ font-size:24px; color:#333; line-height:34px; margin-top:20px;}
// .box05 .box .left .b03{ font-size:18px; color:#666; line-height:28px; margin-top:10px;}
// .box05 .box .left .b04{ width:100%; margin-top:30px;}
// .box05 .box .left .b04 a{ display:block; float:left; margin:0 30px 15px 0;}
// .box05 .box .left .b04 a:last-child{ margin-right:0;}
// .box05 .box .left .b04 a img{ display:block; margin:auto;}
// .box05 .box .left .b06{ font-size:30px; color:#000000; line-height:40px; margin-top:45px;}
// .box05 .box .left .b05{ display:block; margin-top:30px;}
// .box05 .box .left .b05 dt{ display:block; float:left; width:190px; height:50px; border:1px solid #000000; border-radius:5px; text-align:center; margin-right:30px; font-size:18px; line-height:50px;}
// .box05 .box .left .b05 dt a{ color:#000000;}
// .box05 .box .left .b05 dt a:hover{ color:#00d5fd;}
// .box05 .box .left .b05 dd{ display:block; float:left; width:190px; height:50px; border:1px solid #00d5fd; border-radius:5px; text-align:center; margin-right:30px; font-size:18px; line-height:50px; background-color:#00d5fd;}
// .box05 .box .left .b05 dd a{ color:#333;}
// .box05 .box .right{ width:640px; float:left;}
// .box05 .box .right img{ width:100%; display:block;}

/*广告*/
// .gbox{ width:100%; margin-top:30px; position:relative; z-index:2;}
// .gbox .box{ width:1200px; margin:auto;}
// .gbox .box .swiper-slide{ width:100%; display:block; overflow:hidden; border-radius:10px;}
// .gbox .box img{ width:100%; display:block;}
// .gbox .box .swiper-pagination{ width:100%; margin-top:25px; text-align:center; line-height:10px;}
// .gbox .box .swiper-pagination span{ display:inline-table; width:40px; height:5px; background-color:#999; margin:0 10px; border-radius:4px; cursor:pointer;}
// .gbox .box .swiper-pagination span.swiper-pagination-bullet-active{ background-color:#00d5fd;}
  .notice-alert-wrap{
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 12;
    width: 600px;
    padding: 0 6px;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;
    transform: translate(-50%,-50%);
  }
  .notice-alert-wrap .title{
    padding: 10px;
    color: #000;
    font-size: 16px;
    text-align: center;
  }
  .notice-alert-wrap .cont{
    min-height: 80px;
    max-height: 400px;
    padding: 10px;
    color: #666;
    font-size: 13px;
    word-break: break-word;
    overflow-y: auto;
  }
  .notice-alert-wrap .notice-btn{
    width: 280px;
    height: 36px;
    margin: 10px auto 20px;
    color: #000000;
    line-height: 36px;
    border-radius: 4px;
    background: #fcd437;
    cursor: pointer;
    text-align: center;
  }
  .notice-alert-wrap .btn-close{
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    cursor: pointer;
  }
//   // 公告
  .notice-wrap{
    width: 100%;
  }
  .notice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    .notice-tips{
      display: flex;
      align-items: center;
      padding: 0 8px;
    }
    .notice-tips .icon{
      width: 24px;
    }
    .notice-new{
      width: .6rem;
      height: .25rem;
      background-color: #fcd535;
      border-radius: .02rem;
    }
    .notice-more{
      color: #fcd535;
      font-size: .144rem;
      cursor: pointer;
    }
    // .notice-more:hover{
    //   color: #000000;
    //   font-size: 1*16/100 rem;
    // }
    .notice-item{
      flex: 1;
    }
    & > .notice-item {
      font-size: .12rem;
      color: #000000;
      overflow: hidden;
      word-break: keep-all;
      text-align: center;
      span {
        display: inline-block;
        position: relative;
        padding: 0 2em 0 1.5em;
        color: #000000;
        cursor: pointer;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #fcd535;
        }
        & + span {
          border-left:1px solid #c8c8c8;
          padding-left:.3rem;
          margin-right: 1.5rem;
          // &::before {
          //   content: "/";
          //   position: absolute;
          //   left: -0.5em;
          //   color: #54748f;
          // }
        }
      }
    }
  }
// .swiper-pagination{
//     width:100%;
//     bottom: -25px;
//     left:0;
//     right:0;
//     margin:auto;
//   }
//   .swiper-pagination-bullet{
//     background: #999;
//     opacity: 1;
//     width: 40px!important;
//     height: 5px!important;
//     border-radius: 4px;
//     margin:0 4px;
//     color: transparent;
//   }
//   .swiper-pagination-bullet-active{
//     background: #0d73f2;
//   }
</style>
<style>
  .absolute .swiper-pagination{
    display: flex;
    left: 1rem;
    top:.65rem
  }
  .absolute .swiper-pagination .swiper-pagination-bullet{
    font-size: .26rem;
    color: #9f9f9f;
    width: .4rem;
    transform-origin: 0 0;
    transform: rotate(-90deg);
    background: transparent;
    opacity: 1;
  }
  .absolute .swiper-pagination .swiper-pagination-bullet-active{
    background: transparent !important;
    font-size: .41rem;
    color: #000000;
  }
  .absolute .swiper-button-prev{
    width: .7rem;
    height: .7rem;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: .14rem;
    background-image: url(../assets/home/arrow-up.png);
    background-size: .3rem .3rem;
    transform: rotate(-90deg)
  }
  .absolute .swiper-button-next{
    width: .7rem;
    height: .7rem;
    background-color: #ffffff;
    border-radius: 10px;
    background-image: url(../assets/home/arrow-down.png);
    background-size: .3rem .3rem;
    transform: rotate(-90deg)
  }



   .s_ticker {
      height: 120px;
      mask-image: linear-gradient(90deg,transparent 0,#000 25%,#000 75%,transparent);
      -webkit-mask-image: linear-gradient(90deg,transparent 0,#000 25%,#000 75%,transparent);
      position: relative
  }

   .s_ticker .s_ticker_box {
      position: absolute;
      left: 0;
      height: 100%;
      display: flex;
      align-items: center;
      animation: ticker_animate 30s linear infinite;
  }

   .s_ticker .s_ticker_box:hover {
      animation-play-state: paused
  }

   .s_ticker .s_ticker_box ul {
      padding: 0;
      margin: 0;
      display: flex
  }

   .s_ticker .s_ticker_box span:hover {
      background: hsla(0,0%,39%,.05)
  }

   .s_ticker span {
      padding: 0 20px;
      border-radius: 30px;
      height: 60px;
      display: inline-flex;
      align-items: center;
      flex-wrap: nowrap;
      margin-right: 30px
  }
  .mui-18oeoue {
      background-color: #ececec;
      overflow: hidden;
  }
  .mui-1k8stw6 {
      margin: 0px;
      font-weight: 400;
      line-height: 1.5;
      background-color: #fff;
  }
   .s_ibit_block {
      height: 100%;
      width: 100%;
      transition: all .5s ease-in-out .5s;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative
  }

   .s_ibit_block .s_banner_left_001 {
      transform: translate(-552px,-223px) rotate(3turn)
  }

   .s_ibit_block .s_banner_left_002 {
      transform: translate(-430px,-57px) rotate(3turn)
  }

   .s_ibit_block .s_banner_left_003 {
      transform: translate(-323px,7px) rotate(3turn)
  }

   .s_ibit_block .s_banner_left_004 {
      transform: translate(-482px,147px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_001 {
      transform: translate(490px,-250px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_002 {
      transform: translate(340px,-180px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_003 {
      transform: translate(250px,-70px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_004 {
      transform: translate(420px) rotate(3turn)
  }

   .animate_img_group {
      height: 814px;
      position: relative;
      z-index: 1;
      width: 385px;
      transform-style: preserve-3d;
      transition: 1s ease-in-out;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      transform: perspective(1000px) rotateY(0deg)
  }

   .animate_img_group.hover {
      transform: rotateY(180deg)
  }

   .animate_img_group .animate_img {
      transform: rotateY(0deg);
      position: absolute;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden
  }

   .animate_img_group .light_img {
      transform: rotateY(180deg)
  }

   .animate_attempt_group_gsap {
      transform: perspective(2500px) translateX(0) translateY(-20px) scale(.98) rotate(0deg) rotateX(20deg) rotateY(0deg) translateZ(0);
      transform-style: preserve-3d;
      transition: .3s ease-in-out;
      transform-origin: center bottom；
  }

   .animate_attempt_group {
      height: 713px;
      position: relative;
      z-index: 1;
      width: 1002px;
      transform-style: preserve-3d;
      transition: .5s ease-in-out;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      transform: rotateY(0deg)
  }

   .animate_attempt_group.hover {
      transform: rotateY(180deg)
  }

   .animate_attempt_group .animate_img {
      transform: rotateY(0deg);
      position: absolute;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      left: 0;
      width: 100%
  }

   .animate_attempt_group .light_img {
      transform: rotateY(180deg)
  }

  .home-mobile .animate_img_group.hover {
      transform: none
  }

  .home-mobile .animate_img_group.hover img:first-of-type {
      display: none
  }

  .home-mobile .animate_img_group.hover img:nth-of-type(2) {
      display: inline-block;
      transform: none
  }

  @keyframes ticker_animate {
      0% {
          transform: translateZ(0)
      }

      to {
          transform: translate3d(-50%,0,0)
      }
  }

  @keyframes img_animate {
      0% {
          transform: translate(0)
      }

      50% {
          transform: translateY(10px)
      }

      to {
          transform: translate(0)
      }
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue